export default
{
  "request": {
    "responseURL": "list",
  },
  "status": 200,
  "data": [
    {
      "id": "1",
      "name": "Name1",
      "count": 0,
    },
  ]
};
